/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { GslbApiService } from '../http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class GslbPoolsResolver {

    constructor(private gslbService: GslbApiService) {
    }

    public resolve(): Observable<any> {
        return this.gslbService.getBackends();
    }
}
